/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateViewRequest
 */
export interface CreateViewRequest {
  /**
   *
   * @type {string}
   * @memberof CreateViewRequest
   */
  viewType: string;
  /**
   *
   * @type {string}
   * @memberof CreateViewRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateViewRequest
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateViewRequest
   */
  columnConfig: string;
  /**
   *
   * @type {string}
   * @memberof CreateViewRequest
   */
  filters: string;
}

/**
 * Check if a given object implements the CreateViewRequest interface.
 */
export function instanceOfCreateViewRequest(
  value: object,
): value is CreateViewRequest {
  if (!("viewType" in value) || value["viewType"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("columnConfig" in value) || value["columnConfig"] === undefined)
    return false;
  if (!("filters" in value) || value["filters"] === undefined) return false;
  return true;
}

export function CreateViewRequestFromJSON(json: any): CreateViewRequest {
  return CreateViewRequestFromJSONTyped(json, false);
}

export function CreateViewRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateViewRequest {
  if (json == null) {
    return json;
  }
  return {
    viewType: json["viewType"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    columnConfig: json["columnConfig"],
    filters: json["filters"],
  };
}

export function CreateViewRequestToJSON(json: any): CreateViewRequest {
  return CreateViewRequestToJSONTyped(json, false);
}

export function CreateViewRequestToJSONTyped(
  value?: CreateViewRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    viewType: value["viewType"],
    name: value["name"],
    description: value["description"],
    columnConfig: value["columnConfig"],
    filters: value["filters"],
  };
}
